<div class="flex h-full flex-col">
  <div class="screen-container tiny-container my-auto">
    <dojo-loading-sensei />
  </div>
</div>
